/** TODO temporary. will be refactored */

import { createReducer } from '../store.model';

import { sortOrderWithDefault } from './experimental.grid';
import {
    ActionType,
    GridSortAction,
    RootChangeCriteriaAction,
    RootClearStateAction,
    RootInitAction,
    RootInitResultAction,
    RootListLookupsResultAction,
    RootResetAction,
    RootSearchAction,
    RootSearchResultAction,
    RootSelectUserAction,
    RootSelectUserResultAction,
    RootToggleFavoriteAction,
    RootToggleFavoriteResultAction,
} from './search-user.action';
import { statusColumnCheck } from './search-user.function';
import {
    defaultCriteria,
    defaultSortDef,
    defaultState,
    RootState,
} from './search-user.state';

const { builder, reducer } = createReducer<ActionType, RootState>(
    defaultState(),
);

builder
    .add<RootInitAction>(
        ActionType.SEARCH_USER__ROOT__INIT,
        (state, action) => {
            if (state.scope !== action.payload.scope) {
                state = defaultState();
            }
            return {
                ...state,
                pending: {
                    ...state.pending,
                    init: true,
                },
                scope: action.payload.scope,
                authUserId: action.payload.authUserId,
            };
        },
    )
    .add<RootInitResultAction>(
        ActionType.SEARCH_USER__ROOT__INIT_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    init: false,
                },
                lobs: [],
                regions: [],
                areas: [],
                sites: [],
                superGroups: [],
                roles: [],
                teamColumns: action.payload.teamColumns,
                teamRows: action.payload.teamRows,
                teamGridNeedsLayout: Date.now(),
                favoritesColumns: action.payload.favoritesColumns,
                favoritesRows: action.payload.favoritesRows,
                favoritesGridNeedsLayout: Date.now(),
                formNeedsUpdate: Date.now(),
                selectedUserProfile: action.payload.selectedUserProfile,
                selectedUser: action.payload.selectedUser,
                selectedUserManager: action.payload.selectedUserManager,
            };
        },
    );

builder.add<RootListLookupsResultAction>(
    ActionType.SEARCH_USER__ROOT__LIST_LOOKUPS_RESULT,
    (state, action) => {
        return {
            ...state,
            lobs: action.payload.lobs,
            regions: action.payload.regions,
            areas: action.payload.areas,
            sites: action.payload.sites,
            superGroups: action.payload.superGroups,
            roles: action.payload.roles,
        };
    },
);

builder.add<RootChangeCriteriaAction>(
    ActionType.SEARCH_USER__ROOT__CHANGE_CRITERIA,
    (state, action) => {
        // const searchGridNeedsLayout = statusColumnCheck(myState.searchColumns, action.criteria.activeStatus)
        const searchGridNeedsLayout = statusColumnCheck(
            state.searchColumns,
            action.payload.criteria.statusType,
        )
            ? Date.now()
            : state.searchGridNeedsLayout;
        return {
            ...state,
            criteria: action.payload.criteria,
            searchGridNeedsLayout,
        };
    },
);

builder
    .add<RootSearchAction>(ActionType.SEARCH_USER__ROOT__SEARCH, (state) => {
        return {
            ...state,
            pending: {
                ...state.pending,
                search: true,
            },
            searchRows: undefined,
            searchGridNeedsLayout: Date.now(),
        };
    })
    .add<RootSearchResultAction>(
        ActionType.SEARCH_USER__ROOT__SEARCH_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    search: false,
                },
                didInitialSearch: true,
                searchFailed: action.payload.searchFailed,
                searchExceedsMaxCount: action.payload.searchExceedsMaxCount,
                searchColumns: action.payload.columns,
                searchRows: action.payload.rows,
                searchGridNeedsLayout: Date.now(),
            };
        },
    );

builder
    .add<RootSelectUserAction>(
        ActionType.SEARCH_USER__ROOT__SELECT_USER,
        (state) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    selectUser: true,
                },
                teamRows: undefined,
                teamGridNeedsLayout: Date.now(),
            };
        },
    )
    .add<RootSelectUserResultAction>(
        ActionType.SEARCH_USER__ROOT__SELECT_USER_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    selectUser: false,
                },
                teamRows: action.payload.teamRows,
                selectedUserProfile: action.payload.userProfile,
                selectedUser: action.payload.user,
                selectedUserManager: action.payload.manager,
            };
        },
    );

builder.add<RootResetAction>(
    ActionType.SEARCH_USER__ROOT__RESET,
    (state, action) => {
        if (action.payload.hard) {
            return {
                ...defaultState(),
                lobs: [],
                regions: [],
                areas: [],
                sites: [],
                superGroups: [],
                roles: [],
                teamColumns: [],
                teamRows: [],
                teamGridNeedsLayout: Date.now(),
                favoritesColumns: [],
                favoritesRows: [],
                favoritesGridNeedsLayout: Date.now(),
                formNeedsUpdate: Date.now(),
                searchColumns: [],
                searchRows: [],
                searchGridNeedsLayout: Date.now(),
            };
        }

        const criteria = defaultCriteria();
        const searchGridNeedsLayout = statusColumnCheck(
            state.searchColumns,
            criteria.statusType,
        )
            ? Date.now()
            : state.searchGridNeedsLayout;
        return {
            ...state,
            criteria,
            formNeedsUpdate: Date.now(),
            searchGridNeedsLayout,
        };
    },
);

builder
    .add<RootToggleFavoriteAction>(
        ActionType.SEARCH_USER__ROOT__TOGGLE_FAVORITE,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    favorite: {
                        ...(state.pending.favorite || {}),
                        [action.payload.refId]: true,
                    },
                },
            };
        },
    )
    .add<RootToggleFavoriteResultAction>(
        ActionType.SEARCH_USER__ROOT__TOGGLE_FAVORITE_RESULT,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    favorite: {
                        ...(state.pending.favorite || {}),
                        [action.payload.refId]: false,
                    },
                },
                teamGridNeedsLayout: Date.now(),
                favoritesRows: action.payload.favoritesRows,
                favoritesGridNeedsLayout: Date.now(),
                selectedUser: action.payload.selectedUser || state.selectedUser,
            };
        },
    );

builder.add<GridSortAction>(
    ActionType.SEARCH_USER__GRID__SORT,
    (state, action) => {
        const searchSortDefs = sortOrderWithDefault(
            state.searchColumns,
            action.payload.column,
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            state.searchSortDefs && state.searchSortDefs.length
                ? state.searchSortDefs[0]
                : null,
            defaultSortDef(),
        );
        return {
            ...state,
            searchSortDefs,
            searchGridNeedsLayout: Date.now(),
        };
    },
);

builder.add<RootClearStateAction>(
    ActionType.SEARCH_USER__ROOT__CLEAR_STATE,
    () => {
        return defaultState();
    },
);

export default {
    searchUser: reducer,
};
